import { nanoid } from 'nanoid'
import { RichText } from './RichTexts'
import {
  KATHIE,
  IMRAN,
  FRANK,
  KATIE,
  MICHAEL,
  KERRY,
  ZACH,
  AMANDA,
  CHRIS,
  CATHERINE,
  HTT,
  SONGEXPLODE,
  YOUANDMEBOTH,
  HOMECOOKING
} from '../../assets/faculty'

export const FACULTY_DATA = {
  faculty: {
    title: '',
    faculty: [
      {
        id: nanoid(),
        name: 'Kathleen Russo',
        title: 'Director',
        image: KATHIE,
        bio: RichText.Kathleen,
      },
      {
        id: nanoid(),
        name: 'Kerry Donahue',
        title: 'Lead Instructor',
        image: KERRY,
        bio: RichText.Kerry,
      },
      {
        id: nanoid(),
        name: 'Chris O\'Keeffe',
        title: 'Co-Instructor',
        image: CHRIS,
        bio: RichText.Chris,
      },
      {
        id: nanoid(),
        name: 'Amanda McLoughlin',
        title: 'Specialist Instructor',
        image: AMANDA,
        bio: RichText.Amanda,
      },
      {
        id: nanoid(),
        name: 'Zach McNees',
        title: 'Specialist Instructor',
        image: ZACH,
        bio: RichText.Zach,
      },
      {
        id: nanoid(),
        name: 'Catherine Burns',
        title: 'Specialist Instructor',
        image: CATHERINE,
        bio: RichText.Catherine,
      },
      {
        id: nanoid(),
        name: 'Imran Azad',
        title: 'Marketing Director',
        image: IMRAN,
        bio: RichText.Imran,
      },

      
    ],
  },
  adjunctFaculty: {
    title: 'Shows Our Faculty Have Worked On',
    faculty: [
      {
        id: nanoid(),
        name: 'You and Me Both with Hillary Clinton',
        title: '',
        image: YOUANDMEBOTH,
        bio: 'You and Me Both is hosted by Hillary Clinton, featuring candid conversations with notable guests on politics, culture, and the human stories behind them.',
      },
      {
        id: nanoid(),
        name: 'Here’s The Thing with Alec Baldwin',
        title: '',
        image: HTT,
        bio: 'Here’s The Thing is an intimate interview podcast hosted by Alec Baldwin, where he sits down with artists, policymakers, and performers to explore what motivates them.',
      },
      {
        id: nanoid(),
        name: 'Song Exploder with Hrishikesh Hirway',
        title: '',
        image: SONGEXPLODE,
        bio: 'Song Exploder is a podcast created and hosted by Hrishikesh Hirway where musicians take apart their songs and, piece by piece, tell the story of how they were made.',
      },
      {
        id: nanoid(),
        name: 'Home Cooking with Samin Nosrat and Hrishikesh Hirway',
        title: '',
        image: HOMECOOKING,
        bio: 'Home Cooking is a podcast hosted by Samin Nosrat and Hrishikesh Hirway, offering cooking advice, tips, and comfort during the pandemic and beyond.',
      },
    ],
  },
}
